import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const buildCriteria = (password) => [
  { label: '1 minuscule',          met: /[a-z]/.test(password) },
  { label: '1 caractère spécial',  met: /[^\w\s]/.test(password) },
  { label: '1 majuscule',          met: /[A-Z]/.test(password) },
  { label: '8 caractères minimum', met: password.length >= 8 },
  { label: '1 chiffre',            met: /\d/.test(password) },
];

const PasswordField = ({ value, onChange, disabled, inputStyle, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);
  const criteria = buildCriteria(value || '');

  return (
    <>
      <div className="eb-pwfield" style={{ position: 'relative', marginBottom: 20 }}>
        <input
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          disabled={disabled}
          style={{ ...inputStyle, paddingRight: 46, marginTop: 0, marginBottom: 0 }}
          {...rest}
        />
        <button
          type="button"
          onClick={() => setShowPassword(v => !v)}
          tabIndex={-1}
          aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          style={{
            position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)',
            width: 38, height: 38, minHeight: 0, padding: 0, margin: 0,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            background: 'none', border: 'none', borderRadius: 8, boxShadow: 'none', cursor: 'pointer',
            color: 'var(--eb-muted)', fontSize: 17, lineHeight: 1,
          }}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
      {value && (
        <ul
          className="eb-pwcriteria"
          style={{ listStyle: 'none', padding: 0, margin: '-8px 0 12px', fontSize: 13, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '4px 12px', textAlign: 'left' }}
        >
          {criteria.map(({ label, met }) => (
            <li key={label} style={{ display: 'flex', alignItems: 'center', gap: 6, color: met ? 'var(--eb-success)' : 'var(--eb-muted)', whiteSpace: 'nowrap' }}>
              <span style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 16, height: 16, borderRadius: '50%',
                border: `1.5px solid ${met ? 'var(--eb-success)' : 'var(--eb-border-strong)'}`,
                backgroundColor: met ? 'var(--eb-success)' : 'transparent',
                flexShrink: 0, transition: 'background-color 0.15s ease, border-color 0.15s ease',
              }}>
                {met && <span style={{ color: '#fff', fontSize: 10, lineHeight: 1, fontWeight: 700 }}>✓</span>}
              </span>
              {label}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default PasswordField;
